const routes = {
  login: '/login',
  recover: '/recuperar',
  email: '/email',
  reset: '/restablecer',
  home: '/',
  config: '/editar',
}

export default routes
